import { render, staticRenderFns } from "./ExamPackagePracticeDo.vue?vue&type=template&id=48c2481a&scoped=true&"
import script from "./ExamPackagePracticeDo.vue?vue&type=script&lang=js&"
export * from "./ExamPackagePracticeDo.vue?vue&type=script&lang=js&"
import style0 from "./ExamPackagePracticeDo.vue?vue&type=style&index=0&id=48c2481a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c2481a",
  null
  
)

export default component.exports